import { createFileRoute, redirect } from "@tanstack/react-router"
import { shouldRouteDashboardHostToCms } from "@utils/dashboardHost"
import { currentRequestHostname } from "@utils/dashboardHostRuntime"

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if (shouldRouteDashboardHostToCms(await currentRequestHostname(), "/")) {
      throw redirect({ href: "/dashboard" })
    }
    throw redirect({ href: "/ja" })
  },
})
